import { useGetIdentity, useRecordContext, useTranslate } from "ra-core";
import type { Sale } from "../types";

export const SaleName = ({ sale }: { sale?: Sale }) => {
  const { identity, isPending } = useGetIdentity();
  const saleFromContext = useRecordContext<Sale>();
  const finalSale = sale || saleFromContext;
  const translate = useTranslate();
  if (isPending || !finalSale) return null;
  return finalSale.id === identity?.id
    ? translate("simplecrm.contacts.you", { _: "Você" })
    : `${finalSale.first_name} ${finalSale.last_name}`;
};
